import { createApp } from 'vue'
import store from '@/store/store';
import VueAxios from "vue-axios";
import axios from "axios";
import App from './App.vue';
import vue3GoogleLogin from 'vue3-google-login';


createApp(App)
    .use(VueAxios, axios)
    .use(vue3GoogleLogin, {
        clientId: '781905110527-s2rjnapqnlo6hact2j793akl6ln0alvr.apps.googleusercontent.com',
    })
    .use(store)
    .mount('#app')
